import { OldFan } from '@/staff/domain/old-fan/OldFan';

export interface OldFanUi {
  email: string;
}

export const fromOldFan = (fan: OldFan): OldFanUi => ({
  email: fan.email,
});
